export const reduxKey = '@@EarningsCalculator';

//# sourceMappingURL=constants.js.map